<template>
    <div class="tft__match">
        <div class="tft__match-controls">
            <div class="tft__match-controls_item"
                 @click="openChat()"
                 v-if="showChatControl"
                 :class="{active: isMatchInAdminCalls(match.id)}">
                <div class="icon">
                    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.29754 5.63244C3.95476 5.63244 4.48754 5.09966 4.48754 4.44244C4.48754 3.78522 3.95476 3.25244 3.29754 3.25244C2.64033 3.25244 2.10754 3.78522 2.10754 4.44244C2.10754 5.09966 2.64033 5.63244 3.29754 5.63244Z" fill="#00CBCB"/>
                        <path d="M7.13751 5.63244C7.79473 5.63244 8.32751 5.09966 8.32751 4.44244C8.32751 3.78522 7.79473 3.25244 7.13751 3.25244C6.48029 3.25244 5.94751 3.78522 5.94751 4.44244C5.94751 5.09966 6.48029 5.63244 7.13751 5.63244Z" fill="#00CBCB"/>
                        <path d="M10.935 5.63244C11.5922 5.63244 12.125 5.09966 12.125 4.44244C12.125 3.78522 11.5922 3.25244 10.935 3.25244C10.2778 3.25244 9.745 3.78522 9.745 4.44244C9.745 5.09966 10.2778 5.63244 10.935 5.63244Z" fill="#00CBCB"/>
                        <path d="M2.37288 11.9976C2.31452 11.9979 2.2566 11.9878 2.20203 11.9678C2.11643 11.944 2.04087 11.8944 1.98628 11.8263C1.93168 11.7582 1.90087 11.6751 1.89831 11.5889L1.82 8.95518H0.396271C0.132881 8.95518 0 8.66815 0 8.41557V0.45924C0 0.206658 0.132881 0 0.396271 0H13.4163C13.6773 0 14 0.206658 14 0.45924V8.41557C13.9786 8.55553 13.9096 8.68458 13.8038 8.78231C13.6981 8.88004 13.5617 8.94087 13.4163 8.95518H5.63559L2.70983 11.8943C2.66406 11.9331 2.6105 11.9623 2.55251 11.98C2.49453 11.9978 2.43337 12.0038 2.37288 11.9976ZM0.949153 8.0367H2.28271C2.34165 8.03234 2.40089 8.03947 2.45692 8.05768C2.51295 8.07589 2.56463 8.10481 2.60889 8.14272C2.65315 8.18062 2.6891 8.22675 2.71459 8.27835C2.74008 8.32996 2.7546 8.38599 2.75729 8.44313L2.80949 10.4362L5.08746 8.14003C5.13431 8.10072 5.18908 8.07125 5.2483 8.05346C5.30752 8.03568 5.36991 8.02997 5.43153 8.0367H13.0508V0.91848H0.949153V8.0367Z" fill="#00CBCB"/>
                    </svg>
                </div>
                <span>chat</span>
            </div>

            <div class="tft__match-controls_item status" :class="match.status | lowercase">
                {{ match.status }}
            </div>

            <div class="tft__match-controls_item" @click="$emit('openWinnersDialog', match)" v-if="!['FINISHED'].includes(match.status) && match.participants.length">
                <div class="icon">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.29998 12.3926L7.31998 12.9001L7.51498 11.8126L6.72998 11.0326L7.82498 10.8851L8.32248 9.89761L8.80248 10.8926L9.89498 11.0601L9.09748 11.8251L9.27498 12.9151L8.29998 12.3926Z" fill="#00CBCB"/>
                        <path d="M8.23001 8.79242C8.09055 8.79201 7.95327 8.7577 7.83001 8.69242L4.61751 7.01742C4.43859 6.91188 4.29144 6.76004 4.19156 6.57789C4.09169 6.39574 4.04279 6.19003 4.05002 5.98242V2.42992C4.05002 1.79492 4.47501 1.29492 5.01752 1.29492H11.6075C12.15 1.29492 12.575 1.79492 12.575 2.42992V5.97742C12.5837 6.18716 12.5347 6.39526 12.4333 6.57908C12.3319 6.76289 12.182 6.91537 12 7.01992L8.61252 8.69992C8.49394 8.76008 8.36297 8.79175 8.23001 8.79242ZM5.08001 2.29242C5.06032 2.33462 5.0509 2.38088 5.05251 2.42742V5.98242C5.04867 6.0382 5.06364 6.09365 5.09501 6.13992L8.23001 7.77242L11.535 6.12992C11.5632 6.0842 11.5772 6.0311 11.575 5.97742V2.42992C11.5766 2.38338 11.5672 2.33712 11.5475 2.29492L5.08001 2.29242Z" fill="#00CBCB"/>
                        <path d="M8.3125 15.0625C7.60791 15.0625 6.91913 14.8536 6.33328 14.4621C5.74743 14.0707 5.29082 13.5143 5.02118 12.8633C4.75154 12.2123 4.68099 11.496 4.81845 10.805C4.95591 10.1139 5.29521 9.47916 5.79343 8.98093C6.29166 8.48271 6.92643 8.14341 7.61749 8.00595C8.30855 7.86849 9.02485 7.93904 9.67581 8.20868C10.3268 8.47832 10.8832 8.93493 11.2746 9.52078C11.6661 10.1066 11.875 10.7954 11.875 11.5C11.8737 12.4444 11.4979 13.3498 10.8301 14.0176C10.1623 14.6854 9.25693 15.0612 8.3125 15.0625ZM8.3125 8.9375C7.80569 8.9375 7.31025 9.08779 6.88885 9.36936C6.46745 9.65093 6.13901 10.0511 5.94506 10.5194C5.75111 10.9876 5.70036 11.5028 5.79924 11.9999C5.89811 12.497 6.14217 12.9536 6.50054 13.312C6.85891 13.6703 7.31551 13.9144 7.81258 14.0133C8.30966 14.1121 8.82489 14.0614 9.29313 13.8674C9.76136 13.6735 10.1616 13.3451 10.4431 12.9236C10.7247 12.5022 10.875 12.0068 10.875 11.5C10.8743 10.8206 10.6041 10.1692 10.1237 9.68877C9.64331 9.20835 8.99192 8.93816 8.3125 8.9375Z" fill="#00CBCB"/>
                    </svg>
                </div>
                <span>winner</span>
                <div class="tft__match-controls_item-count" v-if="match.results.length">
                    {{ match.results.length }}
                </div>
            </div>

            <div class="tft__match-controls_item right"
                @click="revert"
                 v-if="tournament.getStatus() !== 'FINISHED' && match.status === 'FINISHED' && (match.next_match && match.next_match.status) !== 'FINISHED'">
                <div class="icon">
                    <svg width="16" color="#00E7DF" height="16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 64 64"><g><g><path d="M60.9999 13.7601V29.6301C60.9999 30.1606 60.7892 30.6693 60.4141 31.0443C60.0391 31.4194 59.5303 31.6301 58.9999 31.6301C58.4695 31.6301 57.9608 31.4194 57.5857 31.0443C57.2106 30.6693 56.9999 30.1606 56.9999 29.6301V16.0001H9.99991L16.5899 22.6001C16.8593 22.8769 17.0405 23.2274 17.1105 23.6073C17.1804 23.9871 17.136 24.3792 16.9828 24.7338C16.8296 25.0883 16.5746 25.3894 16.2501 25.5989C15.9255 25.8083 15.5461 25.9166 15.1599 25.9101C14.8946 25.9077 14.6324 25.8525 14.3886 25.7478C14.1448 25.6431 13.9243 25.4909 13.7399 25.3001L2.40991 13.7201L13.7899 2.79012C13.9796 2.60805 14.2033 2.46516 14.4482 2.36963C14.6931 2.27409 14.9545 2.22779 15.2174 2.23336C15.4802 2.23893 15.7394 2.29627 15.98 2.4021C16.2207 2.50793 16.4381 2.66018 16.6199 2.85012C16.9881 3.2567 17.187 3.78863 17.1758 4.33704C17.1647 4.88544 16.9443 5.40885 16.5599 5.80012L10.2199 12.0001H59.2899C59.5208 11.9797 59.7534 12.0103 59.9711 12.0898C60.1889 12.1693 60.3865 12.2957 60.5499 12.4601C60.7157 12.6305 60.842 12.8353 60.9198 13.06C60.9975 13.2847 61.0249 13.5237 60.9999 13.7601Z" fill="currentColor"></path> <path d="M62.65 48.7398L51.27 59.6598C50.8968 60.0196 50.3984 60.2204 49.88 60.2198C49.482 60.2182 49.0935 60.0979 48.7642 59.8743C48.435 59.6507 48.1799 59.3339 48.0317 58.9645C47.8835 58.5951 47.8489 58.1899 47.9324 57.8007C48.0158 57.4115 48.2134 57.056 48.5 56.7798L54.5 50.9998H6.46C5.84978 50.948 5.27491 50.6917 4.82847 50.2724C4.38202 49.8532 4.09011 49.2956 4 48.6898V32.8198C4 32.2894 4.21071 31.7807 4.58579 31.4056C4.96086 31.0305 5.46957 30.8198 6 30.8198C6.53043 30.8198 7.03914 31.0305 7.41421 31.4056C7.78929 31.7807 8 32.2894 8 32.8198V46.9998H55.34L48.45 39.9998C48.0774 39.6206 47.8707 39.1088 47.8754 38.5771C47.88 38.0455 48.0957 37.5375 48.475 37.1648C48.8543 36.7922 49.366 36.5855 49.8977 36.5902C50.4293 36.5949 50.9374 36.8106 51.31 37.1898L62.65 48.7398Z" fill="currentColor"></path></g></g></svg>
                </div>
                <span>revert</span>
            </div>
        </div>
        <div class="tft__players">
            <TftPlayer :results="match.results" v-for="(player, i) in 8" :key="player" :player="match.participants[i] && match.participants[i].participant ? match.participants[i] : null"></TftPlayer>
        </div>
        <div class="tft__final" v-if="match.is_final">
            grand Final
        </div>
    </div>
</template>
<script>
import TftScreenshot from './TftScreenshot'
import SvgIcon from '../SvgIcon'
import {mapActions, mapGetters} from 'vuex'
import TftPlayer from './TftPlayer'
import { REVERT_MATCH_DIALOG } from "../../constants/dialogs";
export default {
    data () {
        return {
            screenshotMatch: null
        }
    },
    props: {
      match: {
          required: true,
          type: Object
      }
    },
    computed: {
        ...mapGetters({
            centrifugeInstance: 'centrifugeInstance',
            tournament: 'tournament',
            getNextMatch: 'getNextMatch',
            status: 'tournamentStatus',
            isActiveChat: 'isActiveChat',
            isMatchInAdminCalls: 'isMatchInAdminCalls'
        }),
        showChatControl: function () {
            return this.match.participants.length && 'FINISHED' !== this.match.status
        },
    },
    mounted () {
      this.subscribeChannel()
    },
    methods: {
        ...mapActions({
            showWinnerDialog: 'showBracketsWinnerDialog',
            showChat: 'OPEN_CHAT',
            showDialog: 'showDialog',
        }),
        subscribeChannel () {
            if (this.centrifugeInstance) {
                let channel = `result.tournament.${this.tournament.getId()}.match.${this.match.id}`
                this.centrifugeInstance.subscribe(channel, (data) => {
                    if (!this.match.results.find(item => item.reporter_id === data.data.reporter_id)) {
                        this.match.results.push(data.data)
                    } else {
                        this.match.results.find(item => item.reporter_id === data.data.reporter_id).image = data.data.image
                    }
                })

                channel = `tournament.${this.tournament.getId()}.match.${this.match.id}`
                if (this.centrifugeInstance) {
                    this.centrifugeInstance.subscribe(channel, (data) => {
                        this.match.status = data.data.status
                    })
                    this.subscribe = true
                }
            }
        },
        revert() {
            this.showDialog({
                type: REVERT_MATCH_DIALOG,
                match: this.match.id,
                tournamentType: 6
            });
        },
        async openChat() {
            const data = {
                match: this.match.id,
                tournament: this.tournament.getId(),
                payload: {
                    channel: this.match.chat_room
                }
            };

            await this.showChat(data);
        },
    },
    components: {
        TftPlayer,
        TftScreenshot,
        SvgIcon
    }
}
</script>
<style scoped lang="scss">
.tft__match {
    margin-bottom: 25px;
    width: 278px;
    min-width: 278px;
    margin-right: 20px;
    .tft__match-controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding-right: 3px;
        min-height: 25px;
        padding-left: 3px;
        .tft__match-controls_item {
            z-index: 2;
            height: 100%;
            .tft__match-controls_item-count {
                right: -16px;
                margin-left: 3px;
                width: 12px;
                z-index: 10;
                font-size: 9px;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 12px;
                border-radius: 100%;
                top: 4px;
                background: #00e7df;
            }
            &.active {
                .icon {
                    svg {
                        path {
                            fill: #FF8A65;
                        }
                    }
                }
                span {
                    color: #FF8A65;
                }
            }
            &.right {
                margin-left: auto;
            }
            &.status {
                position: absolute;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                left: 0;
                right: 0;
                font-size: 12px;
                padding: 5px 3px;
                z-index: 1;
                &.conflict {
                    background: rgb(212, 82, 82);
                    background: radial-gradient(circle,
                        #ffb5b5 0%,
                        rgba(212, 82, 82, 0) 100%);
                }
                &.started {
                    background: #99EC97;
                    background: radial-gradient(circle,
                        #99EC97 0%,
                        rgba(212, 82, 82, 0) 100%);
                }
                &.pending {
                    background: #FFF176;
                    background: radial-gradient(circle,
                        #FFF176 0%,
                        rgba(212, 82, 82, 0) 100%);
                }
                &.finished {
                    background: #F2994A;
                    background: radial-gradient(circle,
                        #F2994A 0%,
                        rgba(212, 82, 82, 0) 100%);
                }
                &.opened, &.waiting {
                    background: #C4C4C4;
                    background: radial-gradient(circle,
                        #C4C4C4 0%,
                        rgba(212, 82, 82, 0) 100%);
                }
            }
            cursor: pointer;
            transition: 0.2s;
            &:hover {
                opacity: 0.8;
            }
            display: flex;
            align-items: center;
            .icon {

                z-index: 9;
                position: relative;
                margin-right: 5px;
                display: flex;
                align-items: center;
            }
            span {
                z-index: 9;
                position: relative;
                letter-spacing: 0.16px;
                text-transform: uppercase;
                color: #06C2BC;
                font-weight: 500;
                font-size: 14px;
                line-height: 29px;
            }
        }
    }
    .tft__players {
        border: 1px solid #E5E5E5;
        border-bottom: none;
    }
    .tft__final {
        background: #018786;
        padding: 3px;
        font-weight: 500;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        letter-spacing: 0.16px;
        text-transform: uppercase;
        border-bottom-right-radius: 7px;
        border-bottom-left-radius: 7px;
        color: #00E7DF;
    }
}
</style>
